import { LinkProps } from "next/link";
import React, { ElementType, MouseEvent as ReactMouseEvent } from "react";

export type BaseButtonProps = React.PropsWithoutRef<{
  onClick?: () => void;
  href?: LinkProps["href"];
  title: string;
  beforeIconPath?: string;
  iconPath?: string;
  type: ButtonType;
  fullWidth?: boolean;
  small?: boolean;
  hasUpChevron?: boolean;
  component?: ElementType;
  isLoading?: boolean;
}>;

export type ButtonProps = React.PropsWithoutRef<{
  onClick?: (event?: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => void;
  title?: string;
  iconPath?: string;
  styles?: string;
  fullWidth?: boolean;
}>;

export type AudioButtonsProps = React.PropsWithoutRef<{
  iconTitle?: string;
  onClick?: () => void;
}>;

export type PlayButtonProps = React.PropsWithoutRef<{
  isPlaying?: boolean;
  onClick?: () => void;
}>;

export type AudioDropdownItemProps = React.PropsWithoutRef<{
  active?: boolean;
  title: string;
  onClick: () => void;
}>;

export type AudioButtonDownloadProps = React.PropsWithoutRef<{
  onClick?: () => void;
  downloading?: boolean;
  downloaded?: boolean;
}>;

export type TinyBtnProps = React.PropsWithoutRef<{
  onClick?: () => void;
  short?: boolean;
  downloading?: boolean;
  downloaded?: boolean;
  issuesTooltipTitle?: boolean;
}>;

export type TinyDownloadButtonsProps = TinyBtnProps &
  React.PropsWithoutRef<{
    postTitle?: string;
    mediaURL?: string;
  }>;

export type TinyBookmarkButtonsProps = TinyBtnProps &
  React.PropsWithoutRef<{
    postTitle?: string;
    postId?: number;
  }>;

export type TinyShareButtonProps = TinyBtnProps &
  React.PropsWithoutRef<{
    postTitle?: string;
    postURL?: string;
  }>;

export type TinyCopyToClipboardProps = TinyBtnProps &
  React.PropsWithoutRef<{
    postURL: string;
  }>;

export type FixedNavbarBtnProps = React.PropsWithRef<{
  onClick?: () => void;
  downloading?: boolean;
  downloaded?: boolean;
  postId?: number;
  postTitle?: string;
  mediaURL?: string;
  title?: string;
}>;

export enum ButtonType {
  Primary,
  PrimaryRounded,
  PrimaryMd,
  Secondary,
  Transparent,
  TransparentRounded,
  TransparentStroked,
}
